import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as c } from "react";
import { I as l } from "../../../../IconBase-CxZyIWw2.js";
const a = c((e, o) => /* @__PURE__ */ s.jsx(
  l,
  {
    ref: o,
    ...e,
    image: (r) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...r,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_4181",
              width: 28,
              height: 28,
              x: 10,
              y: 10,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M34.2 14.4C31.6 11.7 28 10 24 10c-7.7 0-14 6.3-14 14s6.3 14 14 14 14-6.3 14-14c0-3.7-1.5-7.1-3.8-9.6m-7.7-2.9c1.5.3 2.9.9 4.1 1.6-.5.1-1 .2-1.4.4-.7.2-1.4.5-2.1.4-.2 0-.8-.6-1-1.4 0-.6.2-.9.4-1m-8.7 1.3c1 0 1.7.3 2.2.8.3.3.4.8.4 1.3-.3 2.6-1.4 3.8-3.1 3.8-.8 0-1.5.3-1.8 1-.5 1-.1 2.4.5 3.3.7 1.1 1.8 1.7 2.8 1.6 1.2-.1 2.4.3 3 1 .3.4.4.9.1 1.4-.8 1.9 0 4.1.5 5.6.1.2.2.5.2.7.1.4 0 .7-.4.8-.9.3-2.5-.3-3.3-2.1-.7-1.7-2-2.2-2.8-2.5-.2-.1-.6-.2-.7-.3-1.2-2.2-2.9-2.8-4-2.7-.2-.8-.3-1.7-.3-2.6.1-4.7 2.8-8.9 6.7-11.1m-5.9 15.1c.7.1 1.7.4 2.6 2 .3.5.8.7 1.4.9.8.3 1.6.6 2.1 1.7.8 2 2.5 3 3.9 3 .3 0 .6-.1.9-.2 1-.4 1.5-1.3 1.2-2.4-.1-.2-.1-.4-.2-.7-.5-1.4-1.2-3.3-.5-4.7.4-.9.3-1.9-.3-2.7-.8-1.1-2.4-1.7-4.1-1.5-.6.1-1.2-.3-1.7-1s-.7-1.6-.4-2.1c-.1 0 0-.2.5-.2 1.4 0 3.8-.6 4.3-4.9.1-.9-.1-1.7-.7-2.3-.3-.3-.7-.6-1.1-.8 1.3-.5 2.8-.7 4.2-.7.4 0 .8 0 1.1.1-.2.4-.2.9-.1 1.4.2 1 1 2.3 2 2.4.9.1 1.8-.1 2.6-.4 1.4-.5 2.4-.9 3.6.4 1.2 1.2 2.1 2.7 2.7 4.3-.6 0-1.4-.3-2.3-.6-.6-.2-1.205-.495-1.9-.7-1.74-.512-2.6 1.3-3.1 2.3-.1.2-.2.4-.3.5-1.3 2-1.5 2.4-.8 4.3.3.8.5 1 .9 1.5.1.1.3.3.6.5 1.6 1.6 1.6 1.7 1.4 2.4-.1.4-.1.8-.1 1.5 0 1.1.4 2.1.6 2.8.1.2.1.4.2.5-2 1.4-4.5 2.1-7.1 2.1-5.7.2-10.5-3.6-12.1-8.7m20.2 5.9c0-.1 0-.1-.1-.2-.2-.6-.5-1.5-.5-2.4 0-.6.1-1 .1-1.3.2-1.2.1-1.6-1.8-3.5l-.6-.6c-.4-.3-.4-.4-.6-.9-.5-1.4-.5-1.4.7-3.2.1-.2.2-.4.4-.7.5-1 1-1.8 1.6-1.7l1.8.6c1.1.4 2.2.9 3.2.7.3 1 .4 2.1.4 3.3.1 4-1.8 7.6-4.6 9.9"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_4181)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h48v48H0z" }) })
        ]
      }
    )
  }
));
a.displayName = "AgencyGlobeIcon";
export {
  a as AgencyGlobeIcon,
  a as default
};
//# sourceMappingURL=index.js.map
